import firebaseService from '@ameroservices-platform/shared/services/frontendFirebase';

export default async function sendControlCode(ticketNumber, email, callback) {
	const resp = await firebaseService.callFunctionByName('organisationCustomerTicketsSendControlCode', {
		ticketNumber,
		email
	});
	callback(resp.data);
}
